import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { ButtonComponent } from "@shared/controls/button/button.component";
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { ColDef } from "ag-grid-enterprise";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ExportTypeEnum } from "@models/common/export-type.enum";

interface CustomColDef extends ColDef {
  field?: string;
  headerName?: string;
  hide?: boolean;
}

@Component({
  selector: 'app-export-documents-list',
  standalone: true,
  imports: [
    DividerComponent,
    ButtonComponent,
    CheckboxComponent
  ],
  templateUrl: './export-documents-list.component.html',
  styleUrl: './export-documents-list.component.scss'
})
export class ExportDocumentsListComponent {
  @Input() title = 'Export Dcouments List';
  @Input() subTitle = 'documents selected';
  @Input() colDefs: CustomColDef[] = [];
  @Input() numberOfDocuments = 0;
  @Input() exportType: ExportTypeEnum = ExportTypeEnum.EXCEL;
  @Output() confirm = new EventEmitter<string[]>();
  @Output() resetPagination = new EventEmitter<boolean>();

  modal = inject(NgbActiveModal);

  selectAll = false;

  get numberSelectedColumns(): number {
    return this.colDefs?.filter(c => !c.hide && c.headerName)?.length ?? 0;
  }

  onExport(): void {
    const columnsForExport = this.colDefs?.filter(c => !c.hide && c.headerName)
      .map(c => c.field) as string[];
    this.confirm.emit(columnsForExport);
    this.modal.close();
  }

  onClose(): void {
    this.resetPagination.emit(true);
    this.modal.close();
  }

  onCheckboxChange(index: number): void {
    if(this.colDefs?.length) {
      this.colDefs[index].hide = !this.colDefs[index].hide;
    }

    const columnWithHeaderName = this.colDefs?.filter(c => c.headerName) ?? [];
    const selectedColumnNumber = columnWithHeaderName?.filter(c => !c.hide)?.length ?? 0;

    this.selectAll = columnWithHeaderName?.length === selectedColumnNumber;
  }

  onSelectAllChange(selected: boolean): void {
    this.colDefs?.forEach(c => {
      if(c.headerName) {
        c.hide = !selected;
      }
    });

    this.selectAll = selected;
  }
}
